import { ContentType, SectionType } from 'src/types/publishedAssets';
import { findHeroEntity } from './heroSection';

export type SectionNavigationMode = NonNullable<ContentType['metadata']['section_navigation']>;

export function getSectionNavigationMode(sections: SectionType[]): SectionNavigationMode {
  const hero = findHeroEntity(sections);
  if (hero?.metadata?.section_navigation) {
    return hero.metadata.section_navigation;
  }
  return hero?.metadata?.in_page_tab_navigation ? 'single_page_scroll' : 'none';
}
